
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rent-my-motorcycle",
      function () {
        return require("private-next-pages/rent-my-motorcycle.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rent-my-motorcycle"])
      });
    }
  